import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { doLogin, resetPassword } from "../../services/AuthService";
import { useHistory } from "react-router-dom";
import Modal from "../../components/Modal"; // Seu modal de empresas existente
import { Modal as RSModal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"; // Modal do Bootstrap para o reset
import { toast } from "react-toastify";
import isAuthorized from "../../util/RoleUtil";
import { getCookie } from "../../util/CookieUtils";

export const Login = () => {
  // Ajustado para null para evitar aquele bug de string do React 18
  const inputEmail = useRef(null);
  const inputPassword = useRef(null);
  
  const [companies, setCompanies] = useState([]);
  const [isOpenModal, setisOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  
  // NOVOS ESTADOS: Para controlar o modal de recuperar senha
  const [isOpenResetModal, setIsOpenResetModal] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  
  const history = useHistory();

  useEffect(() => {
    const token = getCookie("token");
    console.log("Login useEffec token: ", token);

    if (token) {
      localStorage.setItem("seenOnboarding", "false");
      localStorage.setItem("token", token);
      localStorage.setItem("roles", getCookie("roles"));
      localStorage.setItem("userName", getCookie("userName"));
      localStorage.setItem("companyName", getCookie("companyName"));
      localStorage.setItem("userId", getCookie("userId"));
      history.push("/configuracoes");
    }
  }, []);

  const handleLogin = (e) => {
    setLoading(true);
    e.preventDefault();

    doLogin(inputEmail.current.value, inputPassword.current.value)
      .then((response) => {
        setLoading(false);
        localStorage.setItem("userId", response.userId);
        localStorage.setItem("userName", response.userName);
        localStorage.setItem("roles", response.roles);
        localStorage.setItem("token", response.token);

        if (response.companies?.length > 1) {
          setCompanies(response.companies);
          setisOpenModal(true);
          return;
        }

        localStorage.setItem(
          "companyDocumentNumber",
          response.companies[0] ? response.companies[0].documentNumber : ""
        );

        localStorage.setItem(
          "companyName",
          response.companies[0] ? response.companies[0].fantasyName : response.userName
        );

        if (isAuthorized(["ROLE_ADMIN"])) {
          history.push("/empresas");
          return;
        }
        navigateToRouteRole();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        if (error.response && error.response.status === 422) {
          if (error.response.data == "Sua assinatura venceu entre em contato conosco")
            window.location.href = "https://alconauto.com.br/renovar-assinatura";
          else toast.error(error.response.data);
        } else toast.error("Não foi possivel realizar login");
      });
  };

  // Gatilho para abrir o modal puxando o e-mail do formulário de login
  const handleOpenResetModal = () => {
    const emailDigitado = inputEmail.current?.value || "";
    setResetEmail(emailDigitado); // Joga o e-mail digitado (se houver) para o estado do modal
    setIsOpenResetModal(true);
  };

  // Nova função que processa o envio do Modal de Reset
  const handleSubmitResetPassword = (e) => {
    e.preventDefault();
    setLoading(true);
    
    resetPassword(resetEmail)
      .then((response) => {
        toast.success("Em alguns instantes você receberá sua nova senha em seu E-mail");
        setIsOpenResetModal(false);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 422)
          toast.error(error.response.data);
        else if (error.response && error.response.status === 400)
          toast.warning("Informe o e-mail para resetar sua senha");
        else
          toast.error("Não foi possivel enviar sua nova senha no momento, tente novamente mais tarde");
        setLoading(false);
      });
  };

  function navigateToRouteRole() {
    if (localStorage.getItem("roles").includes(["ROLE_OWNER"]))
      history.push("/dashboard");
    else if (localStorage.getItem("roles").includes(["ROLE_CASHIER"]))
      history.push("/caixa");
    else history.push("/ordem-servicos");
  }

  return (
    <section className="vh-100" style={{ backgroundColor: "#333" }}>
      <Modal companiesList={companies} isOpen={isOpenModal} />
      
      {/* MODAL DE RECUPERAÇÃO DE SENHA - PADRÃO ALCON AUTO */}
      <RSModal
        isOpen={isOpenResetModal}
        toggle={() => setIsOpenResetModal(false)}
        centered
        contentClassName="border-0 rounded-4 shadow-lg"
      >
        <ModalHeader className="border-bottom-0 pb-0 pt-4 px-4" toggle={() => setIsOpenResetModal(false)}>
          <span className="fw-bold text-primary">Recuperar Acesso</span>
        </ModalHeader>
        
        <form onSubmit={handleSubmitResetPassword}>
          <ModalBody className="p-4">
            <p className="text-muted small mb-3">
              Informe o seu e-mail cadastrado abaixo. Nós enviaremos uma nova senha provisória para você em instantes.
            </p>
            <div className="bg-light p-3 rounded-4 border">
              <label className="form-label small fw-bold text-muted text-uppercase">Seu E-mail Cadastrado</label>
              <input
                type="email"
                className="form-control form-control-lg border-2 fw-bold"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
         
              />
            </div>
          </ModalBody>
          <ModalFooter className="border-top-0 p-4 pt-0">
            <div className="d-flex w-100 gap-2">
              <button 
                type="submit" 
                className="btn btn-primary btn-lg fw-bold flex-grow-1 rounded-3 shadow-sm"
                disabled={loading}
              >
                {loading ? (
                  <div className="spinner-border spinner-border-sm" role="status"></div>
                ) : (
                  <>Enviar Nova Senha</>
                )}
              </button>
              <button 
                type="button" 
                onClick={() => setIsOpenResetModal(false)} 
                className="btn btn-outline-danger btn-lg rounded-3 border-2"
                disabled={loading}
              >
                Cancelar
              </button>
            </div>
          </ModalFooter>
        </form>
      </RSModal>

      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col col-sm-10 col-md-10 col-xl-6">
            <div className="card" style={{ borderRadius: "1rem" }}>
              <div className="row g-0">
                <div className="col-md-12 col-lg-12 d-flex align-content-center">
                  <div className="card-body p-4 text-black">
                    <form onSubmit={handleLogin}>
                      <div className="d-flex align-items-center mb-3 pb-1">
                        <img src="/img/logo-h.png" alt="logo-alcon-auto" width={150} height={43} />
                      </div>
                      <div>
                        <h5 className="fw-normal mb-3 pb-3" style={{ letterSpacing: "1px" }}>
                          Faça login na sua conta
                        </h5>
                      </div>

                      <div className="form-outline mb-4">
                        <label className="form-label small fw-bold text-muted text-uppercase" htmlFor="form2Example17">
                          Seu E-mail
                        </label>
                        <input
                          type="email"
                          id="form2Example17"
                          className="form-control form-control-lg border-2"
                          ref={inputEmail}
                          required
                        />
                      </div>
                      <div className="form-outline mb-4">
                        <label className="form-label small fw-bold text-muted text-uppercase" htmlFor="form2Example27">
                          Sua Senha
                        </label>
                        <input
                          type="password"
                          id="form2Example27"
                          className="form-control form-control-lg border-2"
                          ref={inputPassword}
                          required
                        />
                      </div>

                      <div>
                        {loading && !isOpenResetModal ? (
                          <div className="spinner-border mb-4" role="status"></div>
                        ) : (
                          <button className="btn btn-primary btn-lg fw-bold px-4 mb-4 rounded-3 shadow-sm" type="submit">
                           Entrar
                          </button>
                        )}
                      </div>
                      
                      {!loading && (
                        <p style={{ color: "#393f81" }}>
                          Esqueceu sua senha?
                          {/* Modificado o clique para abrir o modal de forma inteligente */}
                          <a
                            onClick={handleOpenResetModal}
                            className="btn p-0"
                            style={{ color: "#0d6efd", marginLeft: "5px" }}
                          >
                            <strong>Clique aqui para recuperar</strong>
                          </a>
                        </p>
                      )}

                      <div className="mt-3">
                        <a href="" style={{ marginRight: "15px" }} className="small text-muted">Termos de uso</a>
                        <a href="" className="small text-muted">Politicas de privacidade</a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;